export default __webpack_public_path__ + "static/media/sbo-dropdown.3275d820.webp";